// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","tableItem":"_2NvaMNACWHJ4hlnA1FeSg6","tableLinks":"ftlget5cCxp7D2tAtndGj"};